// extracted by mini-css-extract-plugin
module.exports = {"blocked":"g_d","loader":"g_f","img":"g_r","wrapper":"g_s","product__wave":"g_t"};